
//******************Exchange Rate Server Calls******************;

import { OverrideCouponsInventoryActions } from './OverrideCouponsInventoryConstants';
import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"


export const OverrideCouponsInventoryServer = {
  //  OverrideCouponsInventory:OverrideCouponsInventory,
  getOverrideCouponsInventory: getOverrideCouponsInventory,
  //  updateOverrideCouponsInventory:updateOverrideCouponsInventory
};

//****************** OverrideCouponsInventory with coupons ******************;

//****************** This Api fetch the Quotas of bussiness Id along with total coupons already generated; grouped by all the years of the contract.

function getOverrideCouponsInventory(data) {

  const request = fetch(ROOT_URL + '/api/coupons/getOverrideCoupons', {
    method: 'Post',
    mode: 'cors',
    headers: { 
      'authorization':getCookie("admin_token_partner"),
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then((response) => {
    response.json().then(response => {
    
      if (response.status == "200") {
        console.log('Business quota details', response)

        store.dispatch({ type: OverrideCouponsInventoryActions.OverrideCouponsInventory_GET.SUCCESS, payload: response.data, ref_data:response.ref_data });
        return;
      } else {
        store.dispatch({ type: OverrideCouponsInventoryActions.OverrideCouponsInventory_GET.FAILED, error:response.error });
        return;
      }
    }).catch((error) => {
      store.dispatch({ type: OverrideCouponsInventoryActions.OverrideCouponsInventory_GET.FAILED,error:failure_messages.OverrideCouponsGetError });
    })
  }).catch((error) => {
    store.dispatch({ type: OverrideCouponsInventoryActions.OverrideCouponsInventory_GET.FAILED,error:failure_messages.OverrideCouponsGetError });
  })
  return { type: OverrideCouponsInventoryActions.OverrideCouponsInventory_GET.LOADING }

};
